(function() {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return;

  // Disable GSAP for Safari
  window.safariDisableGSAP = true;

  function resetAllSlides() {
    var slides = document.querySelectorAll('.main-slideshow .slideshow__slide');
    if (slides.length === 0) return;

    slides.forEach(function(slide) {
      slide.style.opacity = '1';
      slide.style.clipPath = 'none';
      slide.style.webkitClipPath = 'none';
      slide.style.visibility = 'visible';

      var textDivs = slide.querySelectorAll('.split-text div[style*="transform"]');
      textDivs.forEach(function(div) {
        div.style.transform = 'translate(0%, 0%) translate3d(0px, 0px, 0px)';
      });

      var buttons = slide.querySelectorAll('.button, .slideshow-coupon');
      buttons.forEach(function(btn) {
        btn.style.transform = 'translate(0px, 0%)';
        btn.style.visibility = 'visible';
      });

      var bg = slide.querySelector('.slideshow__slide-bg');
      if (bg) {
        bg.style.transform = 'scale(1, 1)';
      }
    });
  }

  var originalGSAP = window.gsap;
  if (originalGSAP && originalGSAP.timeline) {
    window.gsap.timeline = function() {
      return {
        to: function() { return this; },
        from: function() { return this; },
        fromTo: function() { return this; },
        set: function() { return this; },
        add: function() { return this; },
        kill: function() { return this; },
        pause: function() { return this; },
        play: function() { return this; },
        restart: function() { return this; }
      };
    };
  }

  setTimeout(resetAllSlides, 0);
  setTimeout(resetAllSlides, 50);
  setTimeout(resetAllSlides, 150);
  setTimeout(resetAllSlides, 300);
  setTimeout(resetAllSlides, 600);
  setTimeout(resetAllSlides, 1000);
  setTimeout(resetAllSlides, 2000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetAllSlides);
  }

  window.addEventListener('load', resetAllSlides);

  document.addEventListener('DOMContentLoaded', function() {
    var slideshow = document.querySelector('.main-slideshow');
    if (slideshow) {
      slideshow.addEventListener('change.flickity', function() {
        setTimeout(resetAllSlides, 50);
      });
      slideshow.addEventListener('select.flickity', function() {
        setTimeout(resetAllSlides, 50);
      });
    }
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var needsReset = false;
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'style' &&
            mutation.target.classList &&
            (mutation.target.classList.contains('slideshow__slide') ||
             mutation.target.closest('.slideshow__slide'))) {
          needsReset = true;
        }
      });
      if (needsReset) {
        resetAllSlides();
      }
    });

    setTimeout(function() {
      var slideshow = document.querySelector('.main-slideshow');
      if (slideshow) {
        observer.observe(slideshow, {
          attributes: true,
          subtree: true,
          attributeFilter: ['style', 'class']
        });
      }
    }, 500);
  }
})();